<div class="accordian fusion-accordian">
  <div class="panel-group" id="accordion-1423-1" role="tablist">
    <div
      class="fusion-panel panel-default fusion-toggle-no-divider"
      role="tabpanel"
    >
      <div class="panel-heading">
        <style type="text/css">
          @media only screen and (max-width: 800px) {
            .ng-go-back-link {
              margin-bottom: 0px !important;
            }
            div.ng-go-back-link p {
              text-align: left !important;
            }
            .ng-space {
              margin-top: 40px !important;
            }
          }
        </style>
        <div class="ng-go-back-link" style="margin-bottom: -60px">
          <p style="text-align: right; cursor: pointer">
            <a (click)="goToParticipations()" target="_self"
              ><strong>&lt; Torna alle Mie Partecipazioni</strong></a
            >
          </p>
        </div>
        <div style="width: min-content">
          <h4 class="panel-title toggle">
            <a
              aria-expanded="false"
              aria-selected="false"
              aria-controls="97d3a81aaa944fa91"
              role="tab"
              data-toggle="collapse"
              data-parent="#accordion-1423-1"
              data-target="#97d3a81aaa944fa91"
              href="#97d3a81aaa944fa91"
              ><span class="fusion-toggle-icon-wrapper" aria-hidden="true"
                ><i class="fa-fusion-box"></i></span
              ><span class="fusion-toggle-heading">LEGENDA</span></a
            >
          </h4>
        </div>
        <div id="97d3a81aaa944fa91" class="panel-collapse collapse">
          <style>
            ol.number {
              counter-reset: list;
              margin: 10px 0 10px 0;
            }
            ol.number > li {
              list-style: none;
              font-size: 15px;
              color: #333333;
              font-weight: 400;
              margin-top: 10px;
            }
            ol.number > li:before {
              content: counter(list) ") ";
              counter-increment: list;
            }
          </style>
          <div class="panel-body toggle-content fusion-clearfix">
            <h5>
              Tutti i dati obbligatori sono contraddistinti da un asterisco
              &#8220;<strong>*</strong>&#8220;.
            </h5>
            <div
              class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 10px"
            ></div>
            <h5>
              <span class="legendTitle">TITOLI ABILITATIVI</span> In questa
              sezione è possibile mettere il flag su
              <span class="legendLabel">Già Ottenuti</span> per evidenziare la
              certezza delle tempistiche e l’immediata disponibilità del
              cantiere, oppure, va messo il flag su
              <span class="legendLabel">In fase di ottenimento</span> quando si
              è in attesa del rilascio delle autorizzazioni.
            </h5>
            <div
              class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 10px"
            ></div>
            <h5>
              <span class="legendTitle">SUBAPPALTO</span> In questa sezione è
              possibile mettere il flag su
              <span class="legendLabel"
                >Gara condotta a finalità di Subappalto</span
              >
              qualora il Proponente sia un appaltatore (General Contractor,
              Impresa appaltatrice) in cerca di un’impresa esecutrice, oppure,
              va messo il flag su
              <span class="legendLabel">Non è un subappalto</span> quando il
              Proponente è il professionista che assiste il Committente oppure
              il Committente stesso.
            </h5>
            <div
              class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 10px"
            ></div>
            <h5>
              <span class="legendTitle">CARICA FOTO</span> In questa sezione il
              Proponente può caricare file di foto ( max 15 Mb ) valutando se e
              quali rendere pubbliche mettendo il flag su
              <span class="legendLabel">Visibile pubblicamente</span>.
            </h5>
            <div
              class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 10px"
            ></div>
            <h5>
              <span class="legendTitle">CARICA DISEGNI</span> In questa sezione
              il Proponente può caricare file di autocad ( max 100 Mb) valutando
              se e quali disegni rendere pubblici mettendo il flag su
              <span class="legendLabel">Visibile pubblicamente</span>.
            </h5>
            <div
              class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 10px"
            ></div>
            <h5>
              <span class="legendTitle">CARICA ALTRO</span> In questa sezione il
              Proponente può caricare i file degli allegati ( max 50 Mb) che
              ritiene necessari per l’espletamento della gara d’appalto (
              autorizzazioni, relazioni, descrizioni delle opere, piani di
              sicurezza, fac simile di contratto d’appalto,ecc.), valutando se e
              quali rendere pubblici mettendo il flag su<span
                class="legendLabel"
                >Visibile pubblicamente</span
              >.<br />
              Questa sezione può essere utilizzata dal Proponente anche per
              caricare un proprio file di computo, che chiameremo in
              <u>versione semplificata</u>, qualora non intenda utilizzare la
              <u>versione professionale</u> proposta dalla piattaforma.
              Ovviamente il mancato utilizzo della versione di
              <u>computo professionale</u> preclude l’uso di tutti quei servizi
              aggiuntivi di gara previsti quali: processazione dei dati,
              migliore offerta ricevuta, apertura e chiusura fase di sconto,
              apertura e chiusura ultima revisione.
            </h5>
            <div
              class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 10px"
            ></div>
            <h5>
              <span class="legendTitle">COMPUTO METRICO</span> Per compilare il
              computo metrico scaricare il <strong>Template</strong> (<i
                >matrice di computo</i
              >) mediante l'apposita funzione
              <span class="legendLabel">SCARICA TEMPLATE</span> salvarlo in una
              cartella a scelta del proprio computer.
            </h5>
            <h5 style="margin-top: 10px">
              Dopo aver aperto il file computo scaricato, inserire nella
              colonna <u>Prezzo unitario</u> i propri prezzi, inserire eventuali
              note aggiuntive alle voci compilando la colonna <u
                >Note Offerente</u
              > e ricaricare il computo su Skimming utilizzando l'apposita
              funzione <span class="legendLabel">CARICA COMPUTO</span>.
            </h5>
            <h5>
              Con il tasto <span class="legendLabel">SALVA</span> il computo
              viene salvato ma non pubblicato.
            </h5>
            <h5 style="margin-top: 10px">
              Il tasto <span class="legendLabel">SCARICA COMPUTO</span> serve
              all’Offerente che dopo aver fatto <u>SALVA</u> vuole visionare
              quello che ha caricato, oppure per completare o modificare la
              compilazione del computo.
            </h5>
            <h5 style="margin-top: 10px">
              Con il tasto <span class="legendLabel">PUBBLICA</span> l’Offerente
              rende visibile al Proponente il proprio computo metrico, e se
              spuntato con flag dal Proponente la pubblicazione del
              <u><i>miglior prezzo</i></u> .
            </h5>
            <h5>
              Stessa procedura va seguita nelle fasi successive (<u>Sconto</u> 
              ed eventuale <u>Ultima revisione</u>) se richieste dal Proponente.
            </h5>
            <h5>
              Cliccando sul tasto
              <span class="legendLabel">SCARICA PREVENTIVO</span> l’Offerente
              scarica il proprio preventivo e dopo averlo salvato, in una
              cartella a scelta del proprio computer, apporta gli sconti
              ritenuti più opportuni. Con il tasto
              <span class="legendLabel">Ricarica Preventivo Scontato</span> il
              preventivo revisionato viene ricaricato sulla piattaforma per
              essere processato da Skimming e restituire in tempo reale il
              miglior prezzo.
            </h5>
            <div
              class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 10px"
            ></div>
            <h5>
              <span class="legendTitle">DOMANDE E RISPOSTE</span> Cliccando su
              questo Link compare una maschera ove sono possibili le seguenti
              operazioni:
            </h5>
            <ol class="number" type="a">
              <li>
                Ricercare eventuali domande e risposte già inserite mediante il
                tasto <span class="legendLabel">CERCA</span>
              </li>
              <li>
                Porre al Proponente tutte quelle domande che ritiene utili per
                valutare al meglio l’opera da eseguire, cliccando sul Link
                <span class="legendLabel">FAI UNA DOMANDA</span>, compilando il
                form che gli si propone e pubblicandolo con
                <span class="legendLabel">INVIA DOMANDA</span>.
              </li>
              <li>
                Leggere la risposta data dal Proponente cliccando sempre sul
                link <span class="legendLabel">DOMANDE E RISPOSTE</span>.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 30px"
  ></div>

  <h3 style="font-family: Montserrat, Arial, Helvetica, sans-serif">
    <strong>{{ participation.title }}</strong>
  </h3>
  <p style="font-family: Montserrat, Arial, Helvetica, sans-serif">
    <strong
      style="
        background-color: var(--ng-app-theme-yellow-color);
        padding: 3px 10px;
        font-size: 22px;
        color: #ffffff;
      "
      >{{ participationStatusDescr }}</strong
    >
  </p>

  <div
    class="
      fusion-builder-row fusion-builder-row-inner fusion-row
      ng-participation-msg
    "
    *ngIf="!canChangeParticipation && participation.tenderStatus !== 'ACCEPTED'"
  >
    ATTENZIONE: la gara è in attesa di un’azione da parte del richiedente.
  </div>

  <style type="text/css">
    .fusion-accordian #accordion-1423-1 .panel-title a .fa-fusion-box {
      color: #ffffff;
    }

    .fusion-accordian #accordion-1423-1 .panel-title a .fa-fusion-box:before {
      font-size: 16px;
      width: 16px;
    }

    .fusion-accordian #accordion-1423-1 .panel-title a {
      font-size: 18px;
    }

    .fusion-accordian #accordion-1423-1 .fa-fusion-box {
      background-color: #333333;
      border-color: #333333;
    }

    .fusion-accordian #accordion-1423-1 .panel-title a:hover,
    #accordion-1423-1 .fusion-toggle-boxed-mode:hover .panel-title a {
      color: #ffa626;
    }

    .fusion-accordian #accordion-1423-1 .panel-title .active .fa-fusion-box,
    .fusion-accordian #accordion-1423-1 .panel-title a:hover .fa-fusion-box {
      background-color: #ffa626 !important;
      border-color: #ffa626 !important;
    }

    .button-default-disabled {
      background-image: linear-gradient(
        to top,
        var(--ng-app-dark-grey-color),
        var(--ng-app-dark-grey-color)
      );
      cursor: auto;
    }

    a.button-default-disabled span {
      color: #ffffff !important;
    }
  </style>

  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 40px"
  ></div>
  <p><strong>INFORMAZIONI GENERALI GARA</strong></p>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 20px"
  ></div>

  <ul
    class="fusion-checklist fusion-checklist-1"
    style="font-size: 16px; line-height: 27.2px"
  >
    <li class="fusion-li-item">
      <span
        style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
        class="icon-wrapper circle-no"
        ><i class="fusion-li-icon fa-info fas" style="color: #333333"></i
      ></span>
      <div class="fusion-li-item-content" style="margin-left: 38.4px">
        <p>TITOLO DELLA GARA*</p>
      </div>
    </li>
  </ul>
  <div class="fusion-button-wrapper fusion-align-block">
    <style type="text/css">
      .fusion-button.button-1 .fusion-button-text,
      .fusion-button.button-1 i {
        color: #a5a5a5;
      }

      .fusion-button.button-1 .fusion-button-icon-divider {
        border-color: #a5a5a5;
      }

      .fusion-button.button-1:hover .fusion-button-text,
      .fusion-button.button-1:hover i,
      .fusion-button.button-1:focus .fusion-button-text,
      .fusion-button.button-1:focus i,
      .fusion-button.button-1:active .fusion-button-text,
      .fusion-button.button-1:active {
        color: #ffffff;
      }

      .fusion-button.button-1:hover .fusion-button-icon-divider,
      .fusion-button.button-1:hover .fusion-button-icon-divider,
      .fusion-button.button-1:active .fusion-button-icon-divider {
        border-color: #ffffff;
      }

      .fusion-button.button-1:hover,
      .fusion-button.button-1:focus,
      .fusion-button.button-1:active {
        border-color: #ffffff;
      }

      .fusion-button.button-1 {
        border-color: #333333;
        border-radius: 0px;
      }

      .fusion-button.button-1 {
        background: #ffffff;
      }

      .fusion-button.button-1:hover,
      .button-1:focus,
      .fusion-button.button-1:active {
        background: #ffffff;
      }
    </style>
    <input
      type="text"
      placeholder="Titolo"
      value="{{ participation.title }}"
      disabled
    />
  </div>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 30px"
  ></div>
  <ul
    class="fusion-checklist fusion-checklist-2"
    style="font-size: 16px; line-height: 27.2px"
  >
    <li class="fusion-li-item">
      <span
        style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
        class="icon-wrapper circle-no"
        ><i
          class="fusion-li-icon fa-align-center fas"
          style="color: #333333"
        ></i
      ></span>
      <div class="fusion-li-item-content" style="margin-left: 38.4px">
        <p>BREVE DESCRIZIONE*</p>
      </div>
    </li>
  </ul>
  <div class="fusion-button-wrapper fusion-align-block">
    <style type="text/css">
      .fusion-button.button-2 .fusion-button-text,
      .fusion-button.button-2 i {
        color: #a5a5a5;
      }

      .fusion-button.button-2 .fusion-button-icon-divider {
        border-color: #a5a5a5;
      }

      .fusion-button.button-2:hover .fusion-button-text,
      .fusion-button.button-2:hover i,
      .fusion-button.button-2:focus .fusion-button-text,
      .fusion-button.button-2:focus i,
      .fusion-button.button-2:active .fusion-button-text,
      .fusion-button.button-2:active {
        color: #ffffff;
      }

      .fusion-button.button-2:hover .fusion-button-icon-divider,
      .fusion-button.button-2:hover .fusion-button-icon-divider,
      .fusion-button.button-2:active .fusion-button-icon-divider {
        border-color: #ffffff;
      }

      .fusion-button.button-2:hover,
      .fusion-button.button-2:focus,
      .fusion-button.button-2:active {
        border-color: #ffffff;
      }

      .fusion-button.button-2 {
        border-color: #333333;
        border-radius: 0px;
      }

      .fusion-button.button-2 {
        background: #ffffff;
      }

      .fusion-button.button-2:hover,
      .button-2:focus,
      .fusion-button.button-2:active {
        background: #ffffff;
      }
    </style>
    <textarea
      type="text"
      value="{{ participation.description }}"
      disabled
    ></textarea>
  </div>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 30px"
  ></div>
  <ul
    class="fusion-checklist fusion-checklist-3"
    style="font-size: 16px; line-height: 27.2px"
  >
    <li class="fusion-li-item">
      <span
        style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
        class="icon-wrapper circle-no"
        ><i class="fusion-li-icon fa-building fas" style="color: #333333"></i
      ></span>
      <div class="fusion-li-item-content" style="margin-left: 38.4px">
        <p>CATEGORIA*</p>
      </div>
    </li>
  </ul>
  <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_5
        fusion-builder-nested-column-1
        fusion-one-fifth
        fusion-column-first
        1_5
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 20%;
        width: calc(20% - ((4% + 4% + 4% + 4%) * 0.2));
        margin-right: 4%;
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-1 ng-category-box {{
          constructionBox
        }}"
        style="
          padding: 5px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
          cursor: default;
        "
        data-bg-url=""
      >
        <span
          class="fusion-imageframe imageframe-none imageframe-1 hover-type-none"
          ><img
            src="/wp-content/uploads/2015/12/Costruzione-300x300-1.png"
            width="300"
            height="300"
            alt=""
            title="Costruzione 300&#215;300"
            class="img-responsive wp-image-1308"
        /></span>
      </div>
    </div>
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_5
        fusion-builder-nested-column-2
        fusion-one-fifth
        1_5
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 20%;
        width: calc(20% - ((4% + 4% + 4% + 4%) * 0.2));
        margin-right: 4%;
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-2 ng-category-box {{
          renovationBox
        }}"
        style="
          padding: 5px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
          cursor: default;
        "
        data-bg-url=""
      >
        <span
          class="fusion-imageframe imageframe-none imageframe-2 hover-type-none"
          ><img
            src="/wp-content/uploads/2020/02/Ristrutturazioni-300x300-1.png"
            width="300"
            height="300"
            alt=""
            title="Ristrutturazioni 300&#215;300"
            class="img-responsive wp-image-1307"
        /></span>
      </div>
    </div>
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_5
        fusion-builder-nested-column-3
        fusion-one-fifth
        1_5
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 20%;
        width: calc(20% - ((4% + 4% + 4% + 4%) * 0.2));
        margin-right: 4%;
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-3 ng-category-box {{
          systemBox
        }}"
        style="
          padding: 5px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
          cursor: default;
        "
        data-bg-url=""
      >
        <span
          class="fusion-imageframe imageframe-none imageframe-3 hover-type-none"
          ><img
            src="/wp-content/uploads/2015/06/Impianti-300x300-1.png"
            width="300"
            height="300"
            alt=""
            title="Impianti 300&#215;300"
            class="img-responsive wp-image-1310"
        /></span>
      </div>
    </div>
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_5
        fusion-builder-nested-column-4
        fusion-one-fifth
        1_5
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 20%;
        width: calc(20% - ((4% + 4% + 4% + 4%) * 0.2));
        margin-right: 4%;
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-4 ng-category-box {{
          excavationBox
        }}"
        style="
          padding: 5px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
          cursor: default;
        "
        data-bg-url=""
      >
        <span
          class="fusion-imageframe imageframe-none imageframe-4 hover-type-none"
          ><img
            src="/wp-content/uploads/2015/12/Scavi-300x300-1.png"
            width="300"
            height="300"
            alt=""
            title="Scavi 300&#215;300"
            class="img-responsive wp-image-1309"
        /></span>
      </div>
    </div>
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_5
        fusion-builder-nested-column-5
        fusion-one-fifth
        fusion-column-last
        1_5
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 20%;
        width: calc(20% - ((4% + 4% + 4% + 4%) * 0.2));
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-5 ng-category-box {{
          demolitionBox
        }}"
        style="
          padding: 5px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
          cursor: default;
        "
        data-bg-url=""
      >
        <span
          class="fusion-imageframe imageframe-none imageframe-5 hover-type-none"
          ><img
            src="/wp-content/uploads/2015/06/Demolizioni-300x300-1.png"
            width="300"
            height="300"
            alt=""
            title="Demolizioni 300&#215;300"
            class="img-responsive wp-image-1311"
        /></span>
      </div>
    </div>
  </div>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 30px"
  ></div>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 60px"
  ></div>
  <p><strong>INFORMAZIONI CONTATTO</strong></p>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 20px"
  ></div>
  <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-11
        fusion-one-half
        fusion-column-first
        1_2
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(50% - ((4%) * 0.5));
        margin-right: 4%;
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-11"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <ul
          class="fusion-checklist fusion-checklist-1"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <span
              style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
              class="icon-wrapper circle-no"
              ><i
                class="fusion-li-icon fa-address-card fas"
                style="color: #333333"
              ></i
            ></span>
            <div class="fusion-li-item-content" style="margin-left: 38.4px">
              <p>NOME* (NP)</p>
            </div>
          </li>
        </ul>
        <div class="fusion-button-wrapper fusion-align-block">
          <style type="text/css">
            .fusion-button.button-4 .fusion-button-text,
            .fusion-button.button-4 i {
              color: #333333;
            }

            .fusion-button.button-4 .fusion-button-icon-divider {
              border-color: #333333;
            }

            .fusion-button.button-4:hover .fusion-button-text,
            .fusion-button.button-4:hover i,
            .fusion-button.button-4:focus .fusion-button-text,
            .fusion-button.button-4:focus i,
            .fusion-button.button-4:active .fusion-button-text,
            .fusion-button.button-4:active {
              color: #ffffff;
            }

            .fusion-button.button-4:hover .fusion-button-icon-divider,
            .fusion-button.button-4:hover .fusion-button-icon-divider,
            .fusion-button.button-4:active .fusion-button-icon-divider {
              border-color: #ffffff;
            }

            .fusion-button.button-4:hover,
            .fusion-button.button-4:focus,
            .fusion-button.button-4:active {
              border-color: #ffffff;
            }

            .fusion-button.button-4 {
              border-color: #333333;
              border-radius: 0px;
            }

            .fusion-button.button-4 {
              background: #ffffff;
            }

            .fusion-button.button-4:hover,
            .button-4:focus,
            .fusion-button.button-4:active {
              background: #ffffff;
            }
          </style>
          <input type="text" value="{{ participation.contactName }}" disabled />
        </div>
        <div class="fusion-sep-clear"></div>
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 30px"
        ></div>
        <ul
          class="fusion-checklist fusion-checklist-2"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <span
              style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
              class="icon-wrapper circle-no"
              ><i
                class="fusion-li-icon fa fa-envelope"
                style="color: #333333"
              ></i
            ></span>
            <div class="fusion-li-item-content" style="margin-left: 38.4px">
              <p>EMAIL* (NP)</p>
            </div>
          </li>
        </ul>
        <div class="fusion-button-wrapper fusion-align-block">
          <style type="text/css">
            .fusion-button.button-5 .fusion-button-text,
            .fusion-button.button-5 i {
              color: #333333;
            }

            .fusion-button.button-5 .fusion-button-icon-divider {
              border-color: #333333;
            }

            .fusion-button.button-5:hover .fusion-button-text,
            .fusion-button.button-5:hover i,
            .fusion-button.button-5:focus .fusion-button-text,
            .fusion-button.button-5:focus i,
            .fusion-button.button-5:active .fusion-button-text,
            .fusion-button.button-5:active {
              color: #ffffff;
            }

            .fusion-button.button-5:hover .fusion-button-icon-divider,
            .fusion-button.button-5:hover .fusion-button-icon-divider,
            .fusion-button.button-5:active .fusion-button-icon-divider {
              border-color: #ffffff;
            }

            .fusion-button.button-5:hover,
            .fusion-button.button-5:focus,
            .fusion-button.button-5:active {
              border-color: #ffffff;
            }

            .fusion-button.button-5 {
              border-color: #333333;
              border-radius: 0px;
            }

            .fusion-button.button-5 {
              background: #ffffff;
            }

            .fusion-button.button-5:hover,
            .button-5:focus,
            .fusion-button.button-5:active {
              background: #ffffff;
            }
          </style>
          <input
            type="email"
            value="{{ participation.contactEmail }}"
            disabled
          />
        </div>
      </div>
    </div>
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-12
        fusion-one-half
        fusion-column-last
        1_2
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(50% - ((4%) * 0.5));
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-12"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <ul
          class="fusion-checklist fusion-checklist-4"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <span
              style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
              class="icon-wrapper circle-no"
              ><i class="fusion-li-icon fa fa-phone" style="color: #333333"></i
            ></span>
            <div class="fusion-li-item-content" style="margin-left: 38.4px">
              <p>TELEFONO* (NP)</p>
            </div>
          </li>
        </ul>
        <div class="fusion-button-wrapper fusion-align-block">
          <style type="text/css">
            .fusion-button.button-7 .fusion-button-text,
            .fusion-button.button-7 i {
              color: #333333;
            }

            .fusion-button.button-7 .fusion-button-icon-divider {
              border-color: #333333;
            }

            .fusion-button.button-7:hover .fusion-button-text,
            .fusion-button.button-7:hover i,
            .fusion-button.button-7:focus .fusion-button-text,
            .fusion-button.button-7:focus i,
            .fusion-button.button-7:active .fusion-button-text,
            .fusion-button.button-7:active {
              color: #ffffff;
            }

            .fusion-button.button-7:hover .fusion-button-icon-divider,
            .fusion-button.button-7:hover .fusion-button-icon-divider,
            .fusion-button.button-7:active .fusion-button-icon-divider {
              border-color: #ffffff;
            }

            .fusion-button.button-7:hover,
            .fusion-button.button-7:focus,
            .fusion-button.button-7:active {
              border-color: #ffffff;
            }

            .fusion-button.button-7 {
              border-color: #333333;
              border-radius: 0px;
            }

            .fusion-button.button-7 {
              background: #ffffff;
            }

            .fusion-button.button-7:hover,
            .button-7:focus,
            .fusion-button.button-7:active {
              background: #ffffff;
            }
          </style>
          <input
            type="text"
            value="{{ participation.contactPhone }}"
            disabled
          />
        </div>
        <ul
          class="fusion-checklist fusion-checklist-4"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <div class="fusion-li-item-content" style="margin-left: 38.4px">
              <p></p>
            </div>
          </li>
        </ul>
        <div class="fusion-button-wrapper fusion-align-block">
          <style type="text/css">
            .fusion-button.button-7 .fusion-button-text,
            .fusion-button.button-7 i {
              color: #333333;
            }

            .fusion-button.button-7 .fusion-button-icon-divider {
              border-color: #333333;
            }

            .fusion-button.button-7:hover .fusion-button-text,
            .fusion-button.button-7:hover i,
            .fusion-button.button-7:focus .fusion-button-text,
            .fusion-button.button-7:focus i,
            .fusion-button.button-7:active .fusion-button-text,
            .fusion-button.button-7:active {
              color: #ffffff;
            }

            .fusion-button.button-7:hover .fusion-button-icon-divider,
            .fusion-button.button-7:hover .fusion-button-icon-divider,
            .fusion-button.button-7:active .fusion-button-icon-divider {
              border-color: #ffffff;
            }

            .fusion-button.button-7:hover,
            .fusion-button.button-7:focus,
            .fusion-button.button-7:active {
              border-color: #ffffff;
            }

            .fusion-button.button-7 {
              border-color: #333333;
              border-radius: 0px;
            }

            .fusion-button.button-7 {
              background: #ffffff;
            }

            .fusion-button.button-7:hover,
            .button-7:focus,
            .fusion-button.button-7:active {
              background: #ffffff;
            }
          </style>
        </div>
      </div>
    </div>
  </div>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 60px"
  ></div>
  <p><strong>UBICAZIONE CANTIERE</strong></p>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 20px"
  ></div>
  <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-22
        fusion-one-half
        fusion-column-first
        1_2
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(50% - ((4% + 4%) * 0.5));
        margin-right: 4%;
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-22"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <ul
          class="fusion-checklist fusion-checklist-14"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <span
              style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
              class="icon-wrapper circle-no"
              ><i class="fusion-li-icon fa fa-city" style="color: #333333"></i
            ></span>
            <div class="fusion-li-item-content" style="margin-left: 38.4px">
              COMUNE* (NP)
            </div>
          </li>
        </ul>
        <div class="fusion-button-wrapper fusion-align-block">
          <style type="text/css">
            .fusion-button.button-16 .fusion-button-text,
            .fusion-button.button-16 i {
              color: #333333;
            }

            .fusion-button.button-16 .fusion-button-icon-divider {
              border-color: #333333;
            }

            .fusion-button.button-16:hover .fusion-button-text,
            .fusion-button.button-16:hover i,
            .fusion-button.button-16:focus .fusion-button-text,
            .fusion-button.button-16:focus i,
            .fusion-button.button-16:active .fusion-button-text,
            .fusion-button.button-16:active {
              color: #ffffff;
            }

            .fusion-button.button-16:hover .fusion-button-icon-divider,
            .fusion-button.button-16:hover .fusion-button-icon-divider,
            .fusion-button.button-16:active .fusion-button-icon-divider {
              border-color: #ffffff;
            }

            .fusion-button.button-16:hover,
            .fusion-button.button-16:focus,
            .fusion-button.button-16:active {
              border-color: #ffffff;
            }

            .fusion-button.button-16 {
              border-color: #333333;
              border-radius: 0px;
            }

            .fusion-button.button-16 {
              background: #ffffff;
            }

            .fusion-button.button-16:hover,
            .button-16:focus,
            .fusion-button.button-16:active {
              background: #ffffff;
            }
          </style>
          <input type="text" value="{{ participation.city }}" disabled />
        </div>
      </div>
    </div>
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_4
        fusion-builder-nested-column-23
        fusion-one-fourth
        1_4
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 25%;
        width: calc(25% - ((4% + 4%) * 0.25));
        margin-right: 4%;
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-23"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <ul
          class="fusion-checklist fusion-checklist-15"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <span
              style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
              class="icon-wrapper circle-no"
              ><i class="fusion-li-icon fa fa-city" style="color: #333333"></i
            ></span>
            <div class="fusion-li-item-content" style="margin-left: 38.4px">
              PROVINCIA* (NP)
            </div>
          </li>
        </ul>
        <div class="fusion-button-wrapper fusion-align-block">
          <style type="text/css">
            .fusion-button.button-17 .fusion-button-text,
            .fusion-button.button-17 i {
              color: #333333;
            }

            .fusion-button.button-17 .fusion-button-icon-divider {
              border-color: #333333;
            }

            .fusion-button.button-17:hover .fusion-button-text,
            .fusion-button.button-17:hover i,
            .fusion-button.button-17:focus .fusion-button-text,
            .fusion-button.button-17:focus i,
            .fusion-button.button-17:active .fusion-button-text,
            .fusion-button.button-17:active {
              color: #ffffff;
            }

            .fusion-button.button-17:hover .fusion-button-icon-divider,
            .fusion-button.button-17:hover .fusion-button-icon-divider,
            .fusion-button.button-17:active .fusion-button-icon-divider {
              border-color: #ffffff;
            }

            .fusion-button.button-17:hover,
            .fusion-button.button-17:focus,
            .fusion-button.button-17:active {
              border-color: #ffffff;
            }

            .fusion-button.button-17 {
              border-color: #333333;
              border-radius: 0px;
            }

            .fusion-button.button-17 {
              background: #ffffff;
            }

            .fusion-button.button-17:hover,
            .button-17:focus,
            .fusion-button.button-17:active {
              background: #ffffff;
            }
          </style>
          <input type="text" value="{{ provinceDescription }}" disabled />
        </div>
      </div>
    </div>
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_4
        fusion-builder-nested-column-24
        fusion-one-fourth
        fusion-column-last
        1_4
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 25%;
        width: calc(25% - ((4% + 4%) * 0.25));
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-24"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <ul
          class="fusion-checklist fusion-checklist-16"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <span
              style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
              class="icon-wrapper circle-no"
              ><i class="fusion-li-icon fa fa-city" style="color: #333333"></i
            ></span>
            <div class="fusion-li-item-content" style="margin-left: 38.4px">
              CAP* (NP)
            </div>
          </li>
        </ul>
        <div class="fusion-button-wrapper fusion-align-block">
          <style type="text/css">
            .fusion-button.button-18 .fusion-button-text,
            .fusion-button.button-18 i {
              color: #333333;
            }

            .fusion-button.button-18 .fusion-button-icon-divider {
              border-color: #333333;
            }

            .fusion-button.button-18:hover .fusion-button-text,
            .fusion-button.button-18:hover i,
            .fusion-button.button-18:focus .fusion-button-text,
            .fusion-button.button-18:focus i,
            .fusion-button.button-18:active .fusion-button-text,
            .fusion-button.button-18:active {
              color: #ffffff;
            }

            .fusion-button.button-18:hover .fusion-button-icon-divider,
            .fusion-button.button-18:hover .fusion-button-icon-divider,
            .fusion-button.button-18:active .fusion-button-icon-divider {
              border-color: #ffffff;
            }

            .fusion-button.button-18:hover,
            .fusion-button.button-18:focus,
            .fusion-button.button-18:active {
              border-color: #ffffff;
            }

            .fusion-button.button-18 {
              border-color: #333333;
              border-radius: 0px;
            }

            .fusion-button.button-18 {
              background: #ffffff;
            }

            .fusion-button.button-18:hover,
            .button-18:focus,
            .fusion-button.button-18:active {
              background: #ffffff;
            }
          </style>
          <input type="text" value="{{ participation.zipCode }}" disabled />
        </div>
      </div>
    </div>
  </div>
  <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_2_3
        fusion-builder-nested-column-25
        fusion-two-third
        fusion-column-first
        2_3
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 66.66%;
        width: calc(66.66% - ((4%) * 0.6666));
        margin-right: 4%;
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-25"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <ul
          class="fusion-checklist fusion-checklist-17"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <span
              style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
              class="icon-wrapper circle-no"
              ><i class="fusion-li-icon fa fa-road" style="color: #333333"></i
            ></span>
            <div class="fusion-li-item-content" style="margin-left: 38.4px">
              INDIRIZZO* (NP)
            </div>
          </li>
        </ul>
        <div class="fusion-button-wrapper fusion-align-block">
          <style type="text/css">
            .fusion-button.button-19 .fusion-button-text,
            .fusion-button.button-19 i {
              color: #333333;
            }

            .fusion-button.button-19 .fusion-button-icon-divider {
              border-color: #333333;
            }

            .fusion-button.button-19:hover .fusion-button-text,
            .fusion-button.button-19:hover i,
            .fusion-button.button-19:focus .fusion-button-text,
            .fusion-button.button-19:focus i,
            .fusion-button.button-19:active .fusion-button-text,
            .fusion-button.button-19:active {
              color: #ffffff;
            }

            .fusion-button.button-19:hover .fusion-button-icon-divider,
            .fusion-button.button-19:hover .fusion-button-icon-divider,
            .fusion-button.button-19:active .fusion-button-icon-divider {
              border-color: #ffffff;
            }

            .fusion-button.button-19:hover,
            .fusion-button.button-19:focus,
            .fusion-button.button-19:active {
              border-color: #ffffff;
            }

            .fusion-button.button-19 {
              border-color: #333333;
              border-radius: 0px;
            }

            .fusion-button.button-19 {
              background: #ffffff;
            }

            .fusion-button.button-19:hover,
            .button-19:focus,
            .fusion-button.button-19:active {
              background: #ffffff;
            }
          </style>
          <input type="text" value="{{ participation.address }}" disabled />
        </div>
      </div>
    </div>
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_3
        fusion-builder-nested-column-26
        fusion-one-third
        fusion-column-last
        1_3
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 33.33%;
        width: calc(33.33% - ((4%) * 0.3333));
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-26"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <ul
          class="fusion-checklist fusion-checklist-18"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <span
              style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
              class="icon-wrapper circle-no"
              ><i
                class="fusion-li-icon fa fa-map-marked-alt"
                style="color: #333333"
              ></i
            ></span>
            <div class="fusion-li-item-content" style="margin-left: 38.4px">
              N° CIVICO (NP)
            </div>
          </li>
        </ul>
        <div class="fusion-button-wrapper fusion-align-block">
          <style type="text/css">
            .fusion-button.button-20 .fusion-button-text,
            .fusion-button.button-20 i {
              color: #333333;
            }

            .fusion-button.button-20 .fusion-button-icon-divider {
              border-color: #333333;
            }

            .fusion-button.button-20:hover .fusion-button-text,
            .fusion-button.button-20:hover i,
            .fusion-button.button-20:focus .fusion-button-text,
            .fusion-button.button-20:focus i,
            .fusion-button.button-20:active .fusion-button-text,
            .fusion-button.button-20:active {
              color: #ffffff;
            }

            .fusion-button.button-20:hover .fusion-button-icon-divider,
            .fusion-button.button-20:hover .fusion-button-icon-divider,
            .fusion-button.button-20:active .fusion-button-icon-divider {
              border-color: #ffffff;
            }

            .fusion-button.button-20:hover,
            .fusion-button.button-20:focus,
            .fusion-button.button-20:active {
              border-color: #ffffff;
            }

            .fusion-button.button-20 {
              border-color: #333333;
              border-radius: 0px;
            }

            .fusion-button.button-20 {
              background: #ffffff;
            }

            .fusion-button.button-20:hover,
            .button-20:focus,
            .fusion-button.button-20:active {
              background: #ffffff;
            }
          </style>
          <input
            class="ng-app-input"
            type="text"
            value="{{ participation.addressNumber }}"
            disabled
          />
        </div>
      </div>
    </div>
  </div>

  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 60px"
  ></div>
  <p><strong>DATE CANTIERE</strong></p>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 20px"
  ></div>
  <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-11
        fusion-one-half
        fusion-column-first
        1_2
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(50% - ((4%) * 0.5));
        margin-right: 4%;
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-11"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <ul
          class="fusion-checklist fusion-checklist-9"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <span
              style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
              class="icon-wrapper circle-no"
              ><i
                class="fusion-li-icon fa-calendar-alt fas"
                style="color: #333333"
              ></i
            ></span>
            <div class="fusion-li-item-content" style="margin-left: 38.4px">
              <p>DATA INIZIO LAVORI (Presunta)*</p>
            </div>
          </li>
        </ul>
        <div class="fusion-button-wrapper fusion-align-block">
          <style type="text/css">
            .fusion-button.button-8 .fusion-button-text,
            .fusion-button.button-8 i {
              color: #c4c4c4;
            }

            .fusion-button.button-8 .fusion-button-icon-divider {
              border-color: #c4c4c4;
            }

            .fusion-button.button-8:hover .fusion-button-text,
            .fusion-button.button-8:hover i,
            .fusion-button.button-8:focus .fusion-button-text,
            .fusion-button.button-8:focus i,
            .fusion-button.button-8:active .fusion-button-text,
            .fusion-button.button-8:active {
              color: #ffffff;
            }

            .fusion-button.button-8:hover .fusion-button-icon-divider,
            .fusion-button.button-8:hover .fusion-button-icon-divider,
            .fusion-button.button-8:active .fusion-button-icon-divider {
              border-color: #ffffff;
            }

            .fusion-button.button-8:hover,
            .fusion-button.button-8:focus,
            .fusion-button.button-8:active {
              border-color: #ffffff;
            }

            .fusion-button.button-8 {
              border-color: #333333;
              border-radius: 0px;
            }

            .fusion-button.button-8 {
              background: #ffffff;
            }

            .fusion-button.button-8:hover,
            .button-8:focus,
            .fusion-button.button-8:active {
              background: #ffffff;
            }
          </style>
          <div
            style="padding: 0"
            class="
              fusion-button
              button-flat
              fusion-button-default-size
              button-custom button-4
              fusion-button-span-yes fusion-button-default-type
            "
          >
            <span
              class="fusion-button-icon-divider button-icon-divider-left"
              style="cursor: default"
              ><i
                class="fa-calendar-alt fas"
                style="color: #c4c4c4 !important; cursor: default"
              ></i
            ></span>
            <input
              type="text"
              value="{{ participation.expectedStartDate }}"
              style="
                padding: 0 0 0 3.5rem !important;
                border-bottom: 0 !important;
              "
              disabled
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-12
        fusion-one-half
        fusion-column-last
        1_2
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(50% - ((4%) * 0.5));
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-12"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <ul
          class="fusion-checklist fusion-checklist-10"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <span
              style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
              class="icon-wrapper circle-no"
              ><i
                class="fusion-li-icon fa-calendar-alt fas"
                style="color: #333333"
              ></i
            ></span>
            <div class="fusion-li-item-content" style="margin-left: 38.4px">
              <p>DATA FINE LAVORI (Presunta)*</p>
            </div>
          </li>
        </ul>
        <div class="fusion-button-wrapper fusion-align-block">
          <style type="text/css">
            .fusion-button.button-9 .fusion-button-text,
            .fusion-button.button-9 i {
              color: #c4c4c4;
            }

            .fusion-button.button-9 .fusion-button-icon-divider {
              border-color: #c4c4c4;
            }

            .fusion-button.button-9:hover .fusion-button-text,
            .fusion-button.button-9:hover i,
            .fusion-button.button-9:focus .fusion-button-text,
            .fusion-button.button-9:focus i,
            .fusion-button.button-9:active .fusion-button-text,
            .fusion-button.button-9:active {
              color: #ffffff;
            }

            .fusion-button.button-9:hover .fusion-button-icon-divider,
            .fusion-button.button-9:hover .fusion-button-icon-divider,
            .fusion-button.button-9:active .fusion-button-icon-divider {
              border-color: #ffffff;
            }

            .fusion-button.button-9:hover,
            .fusion-button.button-9:focus,
            .fusion-button.button-9:active {
              border-color: #ffffff;
            }

            .fusion-button.button-9 {
              border-color: #333333;
              border-radius: 0px;
            }

            .fusion-button.button-9 {
              background: #ffffff;
            }

            .fusion-button.button-9:hover,
            .button-9:focus,
            .fusion-button.button-9:active {
              background: #ffffff;
            }
          </style>
          <div
            style="padding: 0"
            class="
              fusion-button
              button-flat
              fusion-button-default-size
              button-custom button-4
              fusion-button-span-yes fusion-button-default-type
            "
          >
            <span
              class="fusion-button-icon-divider button-icon-divider-left"
              style="cursor: default"
              ><i
                class="fa-calendar-alt fas"
                style="color: #c4c4c4 !important; cursor: default"
              ></i
            ></span>
            <input
              type="text"
              value="{{ participation.expectedEndDate }}"
              style="
                padding: 0 0 0 3.5rem !important;
                border-bottom: 0 !important;
              "
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 60px"
  ></div>
  <p><strong>TITOLI ABILITATIVI*</strong></p>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 20px"
  ></div>
  <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-13
        fusion-one-half
        fusion-column-first
        1_2
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(50% - ((4%) * 0.5));
        margin-right: 4%;
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-13"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <ul
          class="fusion-checklist fusion-checklist-11"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <input
              type="checkbox"
              id="chQualificationsTrue"
              [checked]="participation.qualifications"
              class="yellowBorderedCheckbox"
              disabled
            />
            <label for="chQualificationsTrue"
              ><span style="cursor: default"></span>Già ottenuti</label
            >
          </li>
        </ul>
      </div>
    </div>
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-14
        fusion-one-half
        fusion-column-last
        1_2
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(50% - ((4%) * 0.5));
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-14"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <ul
          class="fusion-checklist fusion-checklist-12"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <input
              type="checkbox"
              id="chQualificationsFalse"
              [checked]="!participation.qualifications"
              class="yellowBorderedCheckbox"
              disabled
            />
            <label for="chQualificationsFalse"
              ><span style="cursor: default"></span>In fase di
              ottenimento</label
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 60px"
  ></div>
  <p><strong>SUBAPPALTO*</strong></p>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 20px"
  ></div>
  <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-15
        fusion-one-half
        fusion-column-first
        1_2
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(50% - ((4%) * 0.5));
        margin-right: 4%;
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-15"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <ul
          class="fusion-checklist fusion-checklist-13"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <input
              type="checkbox"
              id="chSubcontractTrue"
              [checked]="participation.subcontract"
              class="yellowBorderedCheckbox"
              disabled
            />
            <label for="chSubcontractTrue"
              ><span style="cursor: default"></span>Gara condotta a finalità
              Subappalto</label
            >
          </li>
        </ul>
      </div>
    </div>
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-16
        fusion-one-half
        fusion-column-last
        1_2
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(50% - ((4%) * 0.5));
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-16"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <ul
          class="fusion-checklist fusion-checklist-14"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <input
              type="checkbox"
              id="chSubcontractFalse"
              [checked]="!participation.subcontract"
              class="yellowBorderedCheckbox"
              disabled
            />
            <label for="chSubcontractFalse"
              ><span style="cursor: default"></span>Non è un Subappalto</label
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    *ngIf="
      participation.tenderAttachments &&
      participation.tenderAttachments.length > 0
    "
    style="margin-left: auto; margin-right: auto; margin-top: 60px"
  ></div>
  <div
    class="fusion-builder-row fusion-builder-row-inner fusion-row"
    *ngIf="
      participation.tenderAttachments &&
      participation.tenderAttachments.length > 0
    "
  >
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-19
        fusion-one-half
        fusion-column-first
        1_2
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(50% - ((4%) * 0.5));
        margin-right: 4%;
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-19"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <div class="fusion-text">
          <p style="margin-top: 5px"><strong>ALLEGATI GARA</strong></p>
        </div>
      </div>
    </div>
  </div>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    *ngIf="
      participation.tenderAttachments &&
      participation.tenderAttachments.length > 0
    "
    style="margin-left: auto; margin-right: auto; margin-top: 20px"
  ></div>
  <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
    <div *ngFor="let tenderAttachment of participation.tenderAttachments">
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_3_4
          fusion-builder-nested-column-21
          fusion-three-fourth
          fusion-column-first
          3_4
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 75%;
          width: calc(75% - ((4%) * 0.75));
          margin-right: 4%;
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-21"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <div class="fusion-text" style="font-size: 17px; margin-top: 10px">
            <p>
              {{ getDocumentTypeDescription(tenderAttachment) }} &#8211;
              {{ tenderAttachment.fileName }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_4
          fusion-builder-nested-column-22
          fusion-one-fourth
          fusion-column-last
          1_4
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 25%;
          width: calc(25% - ((4%) * 0.25));
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-22"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-10 {
                border-radius: 0px;
              }</style
            ><a
              (click)="openAttachment(tenderAttachment)"
              class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-10
                fusion-button-span-yes fusion-button-default-type
              "
              target="_self"
              ><span class="fusion-button-icon-divider button-icon-divider-left"
                ><i class="fa-save fas"></i></span
              ><span class="fusion-button-text fusion-button-text-left"
                >SCARICA</span
              ></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    *ngIf="
      (participation.attachments && participation.attachments.length > 0) ||
      participation.participationStatus === 'DRAFT'
    "
    style="margin-left: auto; margin-right: auto; margin-top: 60px"
  ></div>
  <div
    class="fusion-builder-row fusion-builder-row-inner fusion-row"
    *ngIf="
      (participation.attachments && participation.attachments.length > 0) ||
      participation.participationStatus === 'DRAFT'
    "
  >
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-19
        fusion-one-half
        fusion-column-first
        1_2
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(50% - ((4%) * 0.5));
        margin-right: 4%;
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-19"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <div class="fusion-text">
          <p style="margin-top: 5px"><strong>ALLEGATI OFFERTA</strong></p>
        </div>
      </div>
    </div>
  </div>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    *ngIf="
      (participation.attachments && participation.attachments.length > 0) ||
      participation.participationStatus === 'DRAFT'
    "
    style="margin-left: auto; margin-right: auto; margin-top: 20px"
  ></div>
  <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
    <div *ngFor="let attachment of participation.attachments">
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-21
          fusion-three-fourth
          fusion-column-first
          1_2
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 50%;
          width: calc(50% - ((4%) * 0.5));
          margin-right: 4%;
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-21"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <div class="fusion-text" style="font-size: 15px; margin-top: 10px">
            <p>
              {{ getDocumentTypeDescription(attachment) }} &#8211;
              {{ attachment.fileName }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-22
          fusion-one-fourth
          fusion-column-last
          1_2
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 50%;
          width: calc(50% - ((4%) * 0.5));
        "
      >
        <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-21
              fusion-one-fourth
              fusion-column-last
              1_2
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 50%;
              width: calc(50% - ((1%) * 0.5));
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-22"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                margin-right: 4%;
              "
              data-bg-url=""
            >
              <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                  .fusion-button.button-10 {
                    border-radius: 0px;
                  }
                </style>
                <a
                  (click)="deleteAttachment(attachment)"
                  [ngStyle]="{
                    visibility: canChangeParticipation ? 'visible' : 'hidden'
                  }"
                  class="
                    fusion-button
                    button-flat
                    fusion-button-default-size
                    button-default button-10
                    fusion-button-span-yes fusion-button-default-type
                  "
                  target="_self"
                  ><span
                    class="fusion-button-icon-divider button-icon-divider-left"
                    ><i class="fa-trash-alt fas"></i></span
                  ><span class="fusion-button-text fusion-button-text-left"
                    >RIMUOVI</span
                  ></a
                >
              </div>
            </div>
          </div>
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-22
              fusion-one-fourth
              fusion-column-last
              1_2
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 50%;
              width: calc(50% - ((1%) * 0.5));
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-22"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                margin-left: 4%;
              "
              data-bg-url=""
            >
              <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                  .fusion-button.button-10 {
                    border-radius: 0px;
                  }
                </style>
                <a
                  (click)="openAttachment(attachment)"
                  class="fusion-button button-flat fusion-button-default-size button-default{{
                    getDownloadButtonStyle(attachment)
                  }} button-10 fusion-button-span-yes fusion-button-default-type"
                  target="_self"
                  ><span
                    class="fusion-button-icon-divider button-icon-divider-left"
                    ><i class="fa-save fas"></i></span
                  ><span class="fusion-button-text fusion-button-text-left"
                    >SCARICA</span
                  ></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 10px"
      ></div>
    </div>
  </div>
  <div *ngIf="canChangeParticipation">
    <div class="fusion-sep-clear"></div>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 20px"
    ></div>
    <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_3
          fusion-builder-nested-column-27
          fusion-one-third
          fusion-column-first
          1_3
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 33.33%;
          width: calc(33.33% - ((4% + 4%) * 0.3333));
          margin-right: 4%;
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-27"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-top: 4px;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-13 {
                border-radius: 0px;
              }
            </style>
            <input
              style="display: none"
              type="file"
              (change)="uploadAttachment('IMAGE', $event)"
              #uploadImageInput
            />
            <a
              (click)="uploadImageInput.click()"
              class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-13
                fusion-button-span-yes fusion-button-default-type
              "
              target="_self"
              ><span class="fusion-button-text">Carica Foto</span></a
            >
          </div>
        </div>
      </div>
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_3
          fusion-builder-nested-column-28
          fusion-one-third
          1_3
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 33.33%;
          width: calc(33.33% - ((4% + 4%) * 0.3333));
          margin-right: 4%;
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-28"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-top: 4px;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-14 {
                border-radius: 0px;
              }
            </style>
            <input
              style="display: none"
              type="file"
              (change)="uploadAttachment('DRAWING', $event)"
              #uploadDrawingInput
            />
            <a
              (click)="uploadDrawingInput.click()"
              class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-14
                fusion-button-span-yes fusion-button-default-type
              "
              target="_self"
              ><span class="fusion-button-text">Carica Disegni</span></a
            >
          </div>
        </div>
      </div>
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_3
          fusion-builder-nested-column-29
          fusion-one-third
          fusion-column-last
          1_3
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 33.33%;
          width: calc(33.33% - ((4% + 4%) * 0.3333));
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-29"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-top: 4px;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-15 {
                border-radius: 0px;
              }
            </style>
            <input
              style="display: none"
              type="file"
              (change)="uploadAttachment('OTHER', $event)"
              #uploadOtherInput
            />
            <a
              (click)="uploadOtherInput.click()"
              class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-15
                fusion-button-span-yes fusion-button-default-type
              "
              target="_self"
              ><span class="fusion-button-text">Carica Altro</span></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="participation.participationStatus === 'DRAFT'">
    <div class="fusion-sep-clear"></div>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 60px"
    ></div>
    <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-30
          fusion-one-half
          fusion-column-first
          1_2
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 50%;
          width: calc(50% - ((4%) * 0.5));
          margin-right: 4%;
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-30"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <div class="fusion-text">
            <p style="margin-top: 5px"><strong>COMPUTO METRICO</strong></p>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 15px"
      ></div>
      <div
        class="fusion-builder-row fusion-builder-row-inner fusion-row"
        *ngIf="canChangeParticipation"
      >
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_3
            fusion-builder-nested-column-32
            fusion-one-third
            fusion-column-first
            1_3
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 33.33%;
            width: calc(33.33% - ((4% + 4%) * 0.3333));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-32"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-top: 4px;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-16 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="
                  openAttachment(participation.metricCalculationTemplate)
                "
                class="fusion-button button-flat fusion-button-default-size button-default{{
                  getDownloadButtonStyle(
                    participation.metricCalculationTemplate
                  )
                }} fusion-button-span-yes fusion-button-default-type"
                target="_self"
                ><span class="fusion-button-text">Scarica Template</span></a
              >
            </div>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_3
            fusion-builder-nested-column-33
            fusion-one-third
            1_3
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 33.33%;
            width: calc(33.33% - ((4% + 4%) * 0.3333));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-33"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-top: 4px;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-17 {
                  border-radius: 0px;
                }
              </style>
              <input
                style="display: none"
                type="file"
                (change)="uploadAttachment(null, $event)"
                #uploadMetricCalculationDocInput
              />
              <a
                *ngIf="!participation.metricCalculationDoc"
                (click)="uploadMetricCalculationDocInput.click()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text">Carica Computo</span></a
              >
              <a
                *ngIf="participation.metricCalculationDoc"
                (click)="metricCalculationModal.open()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text">Carica Computo</span></a
              >
            </div>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_3
            fusion-builder-nested-column-331
            fusion-one-third
            fusion-column-last
            1_3
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 33.33%;
            width: calc(33.33% - ((4% + 4%) * 0.3333));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-331"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-top: 4px;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-17 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="openAttachment(participation.metricCalculationDoc)"
                class="fusion-button button-flat fusion-button-default-size button-default{{
                  getDownloadButtonStyle(participation.metricCalculationDoc)
                }} fusion-button-span-yes fusion-button-default-type"
                target="_self"
                ><span class="fusion-button-text">Scarica Computo</span></a
              >
            </div>
          </div>
        </div>
      </div>
      <div
        [ngStyle]="{
          visibility: !errorMetricCalculationDoc ? 'hidden' : 'visible'
        }"
        class="ng-{{ metricComputationMsgClass }}"
      >
        {{ metricComputationMsg }}
      </div>
    </div>
  </div>

  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 40px"
  ></div>
  <div class="fusion-sep-clear"></div>
  <div
    *ngIf="participation.totalEstimate"
    style="font-weight: 600; font-style: italic"
  >
    <div class="fusion-sep-clear"></div>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 30px"
    ></div>
    <div style="display: flex; justify-content: space-between; padding: 0 2px">
      <div>TOTALE PREVENTIVO:</div>
      <div>
        &euro;
        {{ participation.totalEstimate | currency: "EUR":"":"0.2-2":"it-IT" }}
      </div>
    </div>
  </div>
  <div class="fusion-sep-clear"></div>
  <div
    *ngIf="participation.discountEstimate"
    style="font-weight: 600; font-style: italic"
  >
    <div class="fusion-sep-clear"></div>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 30px"
    ></div>
    <div style="display: flex; justify-content: space-between; padding: 0 2px">
      <div>PREVENTIVO SCONTATO:</div>
      <div>
        &euro;
        {{
          participation.discountEstimate | currency: "EUR":"":"0.2-2":"it-IT"
        }}
      </div>
    </div>
  </div>
  <div class="fusion-sep-clear"></div>
  <div
    *ngIf="participation.dealEstimate"
    style="font-weight: 600; font-style: italic"
  >
    <div class="fusion-sep-clear"></div>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 30px"
    ></div>
    <div style="display: flex; justify-content: space-between; padding: 0 2px">
      <div>ULTERIORE SCONTO:</div>
      <div>
        &euro;
        {{ participation.dealEstimate | currency: "EUR":"":"0.2-2":"it-IT" }}
      </div>
    </div>
  </div>
  <div
    *ngIf="participation.bestOffer"
    style="font-weight: 600; font-style: italic"
  >
    <div class="fusion-sep-clear"></div>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 30px"
    ></div>
    <div
      style="
        display: flex;
        justify-content: space-between;
        border: 1px solid var(--ng-app-theme-yellow-color);
        padding: 0 2px;
      "
    >
      <div>MIGLIORE OFFERTA:</div>
      <div>
        &euro;
        {{ participation.bestOffer | currency: "EUR":"":"0.2-2":"it-IT" }}
      </div>
    </div>
  </div>
  <div class="fusion-sep-clear"></div>

  <div
    *ngIf="
      canChangeParticipation &&
      (participation.tenderStatus === 'DISCOUNT' ||
        participation.tenderStatus === 'DEAL')
    "
  >
    <div class="fusion-sep-clear"></div>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 60px"
    ></div>
    <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-30
          fusion-one-half
          fusion-column-first
          1_2
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 50%;
          width: calc(50% - ((4%) * 0.5));
          margin-right: 4%;
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-30"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <div class="fusion-text">
            <p style="margin-top: 5px"><strong>PREVENTIVO SCONTATO</strong></p>
          </div>
        </div>
      </div>
    </div>

    <div
      class="fusion-builder-row fusion-builder-row-inner fusion-row"
      *ngIf="!canChangeTender"
    >
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-34
          fusion-one-half
          fusion-column-first
          1_2
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 50%;
          width: calc(50% - ((4%) * 0.5));
          margin-right: 4%;
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-34"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-top: 4px;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-aligncenter">
            <style type="text/css">
              .fusion-button.button-18 {
                border-radius: 0px;
              }
            </style>
            <a
              (click)="openAttachment(participation.metricCalculationDoc, null)"
              class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default
                fusion-button-span-yes fusion-button-default-type
              "
              target="_self"
              ><span class="fusion-button-text">Scarica Preventivo</span></a
            >
          </div>
        </div>
      </div>
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-35
          fusion-one-half
          fusion-column-last
          1_2
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 50%;
          width: calc(50% - ((4%) * 0.5));
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-35"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-top: 4px;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-aligncenter">
            <style type="text/css">
              .fusion-button.button-19 {
                border-radius: 0px;
              }
            </style>
            <input
              style="display: none"
              type="file"
              (change)="uploadAttachment(null, $event)"
              #uploadMetricCalculationDocInput
            />
            <a
              (click)="uploadMetricCalculationDocInput.click()"
              class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default
                fusion-button-span-yes fusion-button-default-type
              "
              target="_self"
              ><span class="fusion-button-text"
                >Ricarica Preventivo Scontato</span
              ></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 30px"
  ></div>
  <div
    [ngStyle]="{ visibility: error === 'no_error' ? 'hidden' : 'visible' }"
    class="ng-{{ errorMessageClass }}"
  >
    {{ error }}
  </div>
  <div class="ng-spinner">
    <img
      *ngIf="loading"
      src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"
    />
  </div>
  <div class="fusion-sep-clear"></div>
  <div
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 30px"
  ></div>
  <div
    class="fusion-builder-row fusion-builder-row-inner fusion-row"
    *ngIf="canChangeParticipation && participation.tenderStatus === 'ONGOING'"
  >
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-34
        fusion-one-half
        fusion-column-first
        1_2
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(50% - ((4%) * 0.5));
        margin-right: 4%;
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-34"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
          margin-top: 4px;
        "
        data-bg-url=""
      >
        <div class="fusion-button-wrapper fusion-aligncenter">
          <style type="text/css">
            .fusion-button.button-18 {
              border-radius: 0px;
            }
          </style>
          <a
            (click)="saveParticipation()"
            appInvalidControlScroll
            class="
              fusion-button
              button-flat
              fusion-button-default-size
              button-default
              fusion-button-default-span fusion-button-default-type
            "
            target="_self"
            ><span class="fusion-button-text">SALVA</span></a
          >
        </div>
      </div>
    </div>
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-35
        fusion-one-half
        fusion-column-last
        1_2
      "
      style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(50% - ((4%) * 0.5));
      "
    >
      <div
        class="fusion-column-wrapper fusion-column-wrapper-35"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
          margin-top: 4px;
        "
        data-bg-url=""
      >
        <div class="fusion-button-wrapper fusion-aligncenter">
          <style type="text/css">
            .fusion-button.button-19 {
              border-radius: 0px;
            }
          </style>
          <!-- (click)="publishConfirmationModal.open()" -->
          <a
            (click)="ManagePublishConfirmationModals()"
            class="
              fusion-button
              button-flat
              fusion-button-default-size
              button-default
              fusion-button-default-span fusion-button-default-type
            "
            target="_self"
            ><span class="fusion-button-text">PUBBLICA</span></a
          >
        </div>
      </div>
    </div>
  </div>
  <div
    class="fusion-button-wrapper fusion-aligncenter"
    *ngIf="
      canChangeParticipation &&
      (participation.tenderStatus === 'DISCOUNT' ||
        participation.tenderStatus === 'DEAL')
    "
  >
    <style type="text/css">
      .fusion-button.button-6 {
        border-radius: 0px;
      }
    </style>
    <a
      (click)="confirmModal.open()"
      class="
        fusion-button
        button-flat
        fusion-button-default-size
        button-default button-6
        fusion-button-default-span fusion-button-default-type
      "
      target="_self"
      ><span class="fusion-button-text">INVIA PREVENTIVO SCONTATO</span></a
    >
  </div>

  <div>
    <div class="fusion-sep-clear"></div>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 50px"
    ></div>
    <p (click)="goToQuestionsAndAnswers()" style="cursor: pointer">
      <a target="_self"><strong>Domande e risposte &gt;</strong></a>
    </p>
  </div>

  <div
    *ngIf="!canChangeParticipation && participation.tenderStatus !== 'ACCEPTED'"
  >
    <div class="fusion-sep-clear"></div>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 30px"
    ></div>
    <div
      class="
        fusion-builder-row fusion-builder-row-inner fusion-row
        ng-participation-msg
      "
    >
      ATTENZIONE: la gara è in attesa di un’azione da parte del richiedente.
    </div>
  </div>
</div>

<app-modal #metricCalculationModal>
  <ng-template #header>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 100px"
    ></div>
    <div class="fusion-text">
      <h3 style="text-align: center">ATTENZIONE</h3>
    </div>
  </ng-template>
  <ng-template #body>
    <div class="fusion-text">
      <h5>
        Un computo metrico per questa gara è già stato caricato. Procedendo al
        caricamento il file già salvato verrà sovrascritto.
      </h5>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-21
          fusion-one-fourth
          fusion-column-last
          1_2
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 50%;
          width: calc(50% - ((1%) * 0.5));
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-22"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-right: 4%;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-10 {
                border-radius: 0px;
              }
            </style>
            <input
              style="display: none"
              type="file"
              (change)="uploadAttachment(null, $event)"
              #uploadMetricCalculationDocInputModal
            />
            <a
              (click)="uploadMetricCalculationDocInputModal.click()"
              class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-10
                fusion-button-span-yes fusion-button-default-type
              "
              target="_self"
              ><span class="fusion-button-text fusion-button-text-left"
                >CARICA COMPUTO</span
              ></a
            >
          </div>
        </div>
      </div>
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-22
          fusion-one-fourth
          fusion-column-last
          1_2
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 50%;
          width: calc(50% - ((1%) * 0.5));
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-22"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-left: 4%;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-10 {
                border-radius: 0px;
              }
            </style>
            <a
              (click)="metricCalculationModal.close()"
              class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-10
                fusion-button-span-yes fusion-button-default-type
              "
              target="_self"
              ><span class="fusion-button-text fusion-button-text-left"
                >ANNULLA</span
              ></a
            >
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</app-modal>

<app-modal #publishConfirmationModalNotAccepted>
  <ng-template #header>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 100px"
    ></div>
    <div class="fusion-text">
      <h3 style="text-align: center">ATTENZIONE</h3>
    </div>
  </ng-template>
  <ng-template #body>
    <div class="fusion-text">
      <h5>
        La pubblicazione è possibile solo dopo l'accettazione della candidatura
        da parte del proponente.
      </h5>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-21
          fusion-one-fourth
          fusion-column-last
          1_2
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 100%;
          width: calc(100% - ((1%) * 0.5));
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-22"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-right: 4%;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-10 {
                border-radius: 0px;
              }
            </style>
            <a
              (click)="publishConfirmationModalNotAccepted.close()"
              class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-10
                fusion-button-span-yes fusion-button-default-type
              "
              target="_self"
              ><span class="fusion-button-text fusion-button-text-left"
                >HO CAPITO</span
              ></a
            >
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</app-modal>

<app-modal #publishConfirmationModal>
  <ng-template #header>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 100px"
    ></div>
    <div class="fusion-text">
      <h3 style="text-align: center">ATTENZIONE</h3>
    </div>
  </ng-template>
  <ng-template #body>
    <div class="fusion-text">
      <h5>
        Si è sicuri di voler pubblicare la gara? Una volta pubblicata, non sarà
        più possibile modificare la gara e i suoi allegati.
      </h5>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-21
          fusion-one-fourth
          fusion-column-last
          1_2
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 50%;
          width: calc(50% - ((1%) * 0.5));
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-22"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-right: 4%;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-10 {
                border-radius: 0px;
              }
            </style>
            <a
              (click)="publishTender()"
              class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-10
                fusion-button-span-yes fusion-button-default-type
              "
              target="_self"
              ><span class="fusion-button-text fusion-button-text-left"
                >PUBBLICA</span
              ></a
            >
          </div>
        </div>
      </div>
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-22
          fusion-one-fourth
          fusion-column-last
          1_2
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 50%;
          width: calc(50% - ((1%) * 0.5));
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-22"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-left: 4%;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-10 {
                border-radius: 0px;
              }
            </style>
            <a
              (click)="publishConfirmationModal.close()"
              class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-10
                fusion-button-span-yes fusion-button-default-type
              "
              target="_self"
              ><span class="fusion-button-text fusion-button-text-left"
                >ANNULLA</span
              ></a
            >
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</app-modal>

<app-modal #confirmModal>
  <ng-template #header>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 100px"
    ></div>
    <div class="fusion-text">
      <h3 style="text-align: center">ATTENZIONE</h3>
    </div>
  </ng-template>
  <ng-template #body>
    <div class="fusion-text">
      <h5>
        Si è sicuri di voler inviare il preventivo scontato? Una volta inviato,
        non sarà più possibile modificarlo.
      </h5>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-21
          fusion-one-fourth
          fusion-column-last
          1_2
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 50%;
          width: calc(50% - ((1%) * 0.5));
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-22"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-right: 4%;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-10 {
                border-radius: 0px;
              }
            </style>
            <a
              (click)="sendDiscount()"
              class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-10
                fusion-button-span-yes fusion-button-default-type
              "
              target="_self"
              ><span class="fusion-button-text fusion-button-text-left"
                >INVIA SCONTO</span
              ></a
            >
          </div>
        </div>
      </div>
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-22
          fusion-one-fourth
          fusion-column-last
          1_2
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 50%;
          width: calc(50% - ((1%) * 0.5));
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-22"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-left: 4%;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-10 {
                border-radius: 0px;
              }
            </style>
            <a
              (click)="confirmModal.close()"
              class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-10
                fusion-button-span-yes fusion-button-default-type
              "
              target="_self"
              ><span class="fusion-button-text fusion-button-text-left"
                >ANNULLA</span
              ></a
            >
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</app-modal>
